import { Brand } from '@bb/domain/dist/types';
import theme from 'components/theme';
import React from 'react';
import styled from 'styled-components';

export const MarketingBadgeGoogle = () => (
    <a
      href="https://play.google.com/store/apps/details?id=com.brokerbay.mobile&hl=en_CA&gl=US"
      target="_blank"
      rel="noreferrer"
    >
      <img src="../../img/google-play-badge.png" width="165" />
    </a>
  );

export const MarketingBadgeApple = () => (
    <a
      href="https://apps.apple.com/us/app/brokerbay/id1493427772"
      target="_blank"
      rel="noreferrer"
    >
      <img src="../../img/app-store-badge.svg" width="136" />
    </a>
  );
